import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: {
          SalesHorarioDeTrabajo: 'Business Hour',
          CallDetails: '',
          LearnMoreProductInfo: 'These items are only part of our products, for more information,\n' +
                        'please check with our sales or visit WWW.SJFOOD.US',
        },
      },
      zh: {
        translation: {
          SalesHorarioDeTrabajo: '歡迎在週日-週五的',
          CallDetails: '致電詳詢',
          LearnMoreProductInfo: '以上僅包括本公司部份貨品，如需諮詢更多凍肉、雜貨、蔬菜價錢，請聯繫SALES,\n' +
                        '或登陸本公司網站: WWW.SJFOOD.US 了解更多貨品信息。',
        },
      },
      es: {
        translation: {
          SalesHorarioDeTrabajo: 'Sales horario de trabajo',
          CallDetails: '',
          LearnMoreProductInfo: 'Sólamente algunos de nuestros productos se muestran anteriormente.\n' +
                        'Para más información, visite nuestra página web www.sjfood.us o contacte a nuestros agentes de venta directamente.',
        },
      },
    },
    lng: 'en', // 默认语言
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
